/* istanbul ignore file */
// TODO: Create test file

const API_DOMAIN_CONFIGS = {
  liveStatus: {
    domains: {
      bcom: 'https://api.stores-bloomingdales.com',
      mcom: 'https://api.store-macys.com',
    },
    paths: { availabilities: 'retailer/stores/availabilities' },
    settings: {
      params: { 'filter[is_available]': '1' },
      headers: { 'Content-Type': 'application/json' },
    },
    onSuccess: ({ data = {} }) => !!data?.data?.length,
    onError: () => false,
  },
};

const COMPONENT_PATHS = {
  contextualWidget: {
    floatingWidget: './contextual-widgets/FloatingWidget',
    virtualAdvisorWidget: './contextual-widgets/SalesfloorVirtualAdvisorWidget',
  },
};

const COMMON_POST_FIXES = {
  common: 'expert',
};

const REGISTRY_POST_FIXES = {
  mcomRegistry: 'consultant',
  bcomRegistry: 'concierge',

};

const CONTEXTUAL_WIDGET_COPIES = {
  floatingWidget: {
    default: '',
    copiesPreFix: {
      availableSpecialty: 'chat with a',
      unavailableSpecialty: 'connect with a',
      brand: 'ask a',
    },
    copiesPostFix: {
      /// Specialist
      brand: 'specialist',
      ...REGISTRY_POST_FIXES,
      ...COMMON_POST_FIXES,
    },
  },
  virtualAdvisorWidget: {
    default: 'ask a style expert',
    copiesPreFix: {
      availableSpecialty: 'chat with a',
      unavailableSpecialty: 'connect with a',
    },
    copiesPostFix: {
      // Specialist
      ...REGISTRY_POST_FIXES,
      ...COMMON_POST_FIXES,
    },
  },
};

const HEADSHOT_DATA = {
  tag: '[PHOTO_NAME]',
  url: 'https://images.bloomingdalesassets.com/is/image/BcomMedia/media/SFContextualWidget_Headshot_[PHOTO_NAME].jpg',
};

const SPECIALTY_DATA = {
  bcom: [
    {
      categoryName: 'jewelry & accessories',
      photoName: 'JA',
      specialtyId: 'b9286793afb783e03c81e3b624cefa',
      categories: ['1075159', '1001781', '1096268'],
      topLevelCategoryID: '3376',
    },
    {
      categoryName: 'fine jewelry',
      photoName: 'FJ',
      specialtyId: '221ee32ab2a9d71b996e1701a9fd85',
      categories: ['1005354', '17796', '17804', '20548', '17805', '17806', '19469'],
    },
    {
      categoryName: 'beauty',
      photoName: 'Beauty',
      specialtyId: '6ca358ee27a426e89439dc12520a84',
      categories: ['1074959', '16541', '1096266'],
      topLevelCategoryID: '2921',
    },
    {
      categoryName: 'shoe',
      photoName: 'Shoes',
      specialtyId: 'f21e896b2ce11230e42e326e34602d',
      categories: ['1076162', '19852', '1096260'],
      topLevelCategoryID: '16961',
    },
    {
      categoryName: 'home',
      photoName: 'Home',
      specialtyId: 'cc4774e96cee082fed6cc95c9c87f0',
      categories: ['1039376'],
      topLevelCategoryID: '3865',
    },
    {
      categoryName: 'furniture & mattress',
      photoName: 'Furniture',
      specialtyId: 'f26951aee52ff246ea95abc9950846',
      categories: ['1006362', '22299', '21652', '21653', '1103359', '1001009', '1001971', '1055559', '1006716'],
    },
    {
      categoryName: 'handbag',
      photoName: 'Handbags',
      specialtyId: 'f7ccb136f527c3c5b09833c95a5d2f',
      categories: ['1076167', '22173', '1096269'],
      topLevelCategoryID: '16958',
    },
    {
      categoryName: "women's apparel",
      photoName: 'Womens',
      specialtyId: '17be032075f8f6c70eb155b9f4aca6',
      categories: ['1075059', '1036559', '1096267', '1002845', '1004122'],
      topLevelCategoryID: '2910',
    },
    {
      categoryName: "men's apparel & accessories",
      photoName: 'Mens',
      specialtyId: '6d027c3e67879c35f77a3c62ae15a3',
      categories: ['1075359', '20592'],
      topLevelCategoryID: '3864',
    },
    {
      categoryName: "kid's apparel & accessories",
      photoName: 'Kids',
      specialtyId: '24a47168bfb5ce244666ad0cb3aa11',
      categories: ['1074859', '1067562'],
      topLevelCategoryID: '3866',
    },
    {
      categoryName: 'registry',
      photoName: 'Registry',
      specialtyId: 'd688a663ec2b04a0ff80b4a900b9a4',
    },
  ],
  mcom: [
    {
      categoryName: 'beauty',
      photoName: 'Beauty',
      specialtyId: 'Beauty',
      topLevelCategoryID: '669',
    },
    {
      categoryName: 'celebration',
      photoName: 'Registry',
      specialtyId: 'registry',
    },
  ],
};

const TAG_DATA_KEYS = {
  bcom: 'event_name',
  mcom: 'link_name',
};

const VIRTUAL_ADVISOR_SKELETON_DATA = {
  expanded: {
    attrs: {
      width: '100%',
      height: '104px',
    },
    classes: {
      bcom: ['margin-top-s'],
      mcom: ['margin-top-xs'],
    },
  },
  mini: {
    attrs: {
      width: '300px',
      height: '24px',
    },
    classes: {
      bcom: ['margin-top-xs'],
      mcom: ['margin-top-xs'],
    },
  },
};

const VIRTUAL_ADVISOR_EXPANDED_COPY_DATA = {
  title: {
    text: {
      bcom: 'chat with us!',
      mcom: 'chat with a style expert',
    },
    classNames: {
      bcom: 'label',
      mcom: 'heavy first-letter-cap',
    },
  },
  body: {
    text: [
      {
        text: 'Our experts can answer any questions you have about this item, or help you find something new.',
        types: [
          'available',
          'pending',
        ],
      },
      {
        text: 'Live chat is currently closed. Send a question and a style expert will contact you when they’re back online.',
        types: [
          'unavailable',
        ],
      },
    ],
  },
  link: {
    text: {
      bcom: {
        pending: 'an available',
        available: 'chat now',
        unavailable: 'submit',
      },
      mcom: {
        pending: 'a style',
        available: 'chat now',
        unavailable: 'send',
      },
    },
    classNames: {
      bcom: {
        pending: 'first-letter-cap',
        available: 'first-letter-cap',
        unavailable: 'first-letter-cap',
      },
      mcom: {
        pending: 'first-letter-cap',
        available: 'first-letter-cap--all-words',
        unavailable: 'first-letter-cap',
      },
    },
  },
};

export {
  API_DOMAIN_CONFIGS,
  COMPONENT_PATHS,
  CONTEXTUAL_WIDGET_COPIES,
  HEADSHOT_DATA,
  SPECIALTY_DATA,
  TAG_DATA_KEYS,
  VIRTUAL_ADVISOR_SKELETON_DATA,
  VIRTUAL_ADVISOR_EXPANDED_COPY_DATA,
};
